export default __webpack_public_path__ + "static/brian-clark-881f73067261f7f328ce5720d5ecb747.jpg";